export const FEEDBACK_OPEN = 'FEEDBACK_OPEN';
export const FEEDBACK_CLOSE = 'FEEDBACK_CLOSE';
export const FEEDBACK_SEND_REQUEST = 'FEEDBACK_SEND_REQUEST';
export const FEEDBACK_SEND_SUCCESS = 'FEEDBACK_SEND_SUCCESS';
export const FEEDBACK_SEND_FAILED = 'FEEDBACK_SEND_FAILED';
export const FEEDBACK_CLEAR_FORM = 'FEEDBACK_CLEAR_FORM';
export const FEEDBACK_REPORT_WRONG_PRICE = 'FEEDBACK_REPORT_WRONG_PRICE';
export const INTERCOM_START_CHAT = 'INTERCOM_START_CHAT';

const open = () => ({ type: FEEDBACK_OPEN });
const close = () => ({ type: FEEDBACK_CLOSE });

const startChat = () => ({ type: INTERCOM_START_CHAT });

export const sendRequest = message => ({
  type: FEEDBACK_SEND_REQUEST,
  message,
});

export const sendSuccess = () => ({ type: FEEDBACK_SEND_SUCCESS });

export const sendFailed = message => ({ type: FEEDBACK_SEND_FAILED, message });

export const clearForm = () => ({ type: FEEDBACK_CLEAR_FORM });

export const reportWrongPrice = message => ({
  type: FEEDBACK_REPORT_WRONG_PRICE,
  message,
});

export default {
  open,
  close,
  startChat,
  sendRequest,
};
